/**
 * arts.js — 디자인앤아트대학 이수요건 데이터
 * 출처: 2026학년도 전공 교육과정 (2026_major.pdf)
 *
 * 디자인학부는 커뮤니케이션디자인·패션디자인·공예디자인 전공으로 구성.
 * 1학년 공통 전공핵심: Digital Design1, 2D Design, 3D Design (3개 전공 모두 동일)
 * 1학년 2학기 공통: Color&Design
 */

export const ARTS_REQUIREMENTS = [

  // ── 디자인학부 / 2026학번 / 1학년 1학기 ──────────────────────────────────────
  {
    id:             'design_2026_1_1',
    collegeId:      'arts',
    collegeName:    '디자인앤아트대학',
    departmentId:   'design',
    departmentName: '디자인학부',
    majorId:        'comm_design',
    majorName:      '커뮤니케이션디자인전공',
    admissionYear:  2026,
    grade:          1,
    semester:       1,
    status:         'official',
    requiredCourses: [
      { courseName: 'Digital Design1', courseCode: '08482', type: '전공필수', credits: 3, required: true, matchKeywords: ['Digital Design1', 'DigitalDesign1'] },
      { courseName: '2D Design',       courseCode: '10081', type: '전공필수', credits: 3, required: true, matchKeywords: ['2D Design', '2DDesign'] },
      { courseName: '3D Design',       courseCode: '10082', type: '전공필수', credits: 3, required: true, matchKeywords: ['3D Design', '3DDesign'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 120, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['3개 전공(커뮤니케이션/패션/공예디자인) 공통 전공핵심 과목 기준', '전공별 추가 이수요건은 학과 교육과정표를 확인하세요'],
  },

  // ── 디자인학부 / 2026학번 / 1학년 2학기 ──────────────────────────────────────
  {
    id:             'design_2026_1_2',
    collegeId:      'arts',
    collegeName:    '디자인앤아트대학',
    departmentId:   'design',
    departmentName: '디자인학부',
    majorId:        'comm_design',
    majorName:      '커뮤니케이션디자인전공',
    admissionYear:  2026,
    grade:          1,
    semester:       2,
    status:         'official',
    requiredCourses: [
      { courseName: 'Color&Design', courseCode: '10944', type: '전공필수', credits: 3, required: true, matchKeywords: ['Color&Design', 'Color Design'] },
    ],
    recommendedCourses: [],
    graduationRules: { totalCredits: 120, majorRequiredCredits: null, majorElectiveCredits: null, liberalArtsCredits: null },
    notes: ['3개 전공 공통 과목만 포함 · 전공별 추가 필수과목은 학과 교육과정표 확인'],
  },
]
